import React from "react";
import { useLocation, Link } from "react-router-dom";

//Styles
import styles from "./linkTab.module.css";

//Materila ui
import MenuIcon from "@material-ui/icons/Menu";

function getFullScreenElement() {
    return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozDullscreenElement ||
        document.msFullscreenElement
    );
}

export default function LinkTab({ children, name, hamburger, to, collapsed }) {
    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

    if (to && to.split("/")[2] === "signout") {
        return (
            <button
                to={to}
                className={`${styles.container} ${
                    collapsed ? styles.alignCenter : ""
                }`}
            >
                <div className={styles.left}>
                    {children}
                    <span className={collapsed ? `${styles.hidden}` : ""}>
                        {name}
                    </span>
                </div>
                <div
                    className={`${styles.right} ${
                        collapsed ? styles.hidden : ""
                    }`}
                >
                    {hamburger && <MenuIcon />}
                </div>
            </button>
        );
    }

    if (to === undefined) {
        return (
            <button
                className={`${styles.container} ${
                    collapsed ? styles.alignCenter : ""
                }`}
                onClick={() => {
                    if (getFullScreenElement()) {
                        document.exitFullscreen();
                    } else {
                        document.documentElement
                            .requestFullscreen()
                            .catch((e) => {
                                console.log(e);
                            });
                    }
                }}
            >
                <div className={styles.left}>
                    {children}
                    <span className={collapsed ? `${styles.hidden}` : ""}>
                        {name}
                    </span>
                </div>
                <div
                    className={`${styles.right} ${
                        collapsed ? styles.hidden : ""
                    }`}
                >
                    {hamburger && <MenuIcon />}
                </div>
            </button>
        );
    }

    return (
        <Link
            to={to}
            className={`${styles.container} ${
                splitLocation[2] === to.split("/")[2] ? styles.active : ""
            } ${collapsed ? styles.alignCenter : ""}`}
        >
            <div className={styles.left}>
                {children}
                <span className={collapsed ? `${styles.hidden}` : ""}>
                    {name}
                </span>
            </div>
            <div
                className={`${styles.right} ${collapsed ? styles.hidden : ""}`}
            >
                {hamburger && <MenuIcon />}
            </div>
        </Link>
    );
}
